import { defineComponent as _defineComponent } from 'vue'
import {
 computed, toRefs, getCurrentInstance,
} from 'vue';
import { DataOptions } from 'vuetify';

interface DataPagination {
  page: number;
  pageCount: number;
  itemsPerPage: number;
  itemsLength: number;
}

interface SiffletifyDataFooterProps {
  footer: { options: DataOptions & { itemsPerPageOptions?: number[] }, pagination: DataPagination },
  itemsPerPageOptions?: number[],
  scrollTo?: string,
  maximumVisible?: number
}
type SiffletifyDataFooterEmits = {
  (event: 'update', options: DataOptions & { itemsPerPageOptions?: number[] | undefined }): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'siffletify-data-footer',
  props: {
  footer: null,
  itemsPerPageOptions: null,
  scrollTo: null,
  maximumVisible: null
},
  emits: ["update"],
  setup(__props, { emit: emits }) {

const props = __props;



const {
 footer, itemsPerPageOptions, scrollTo, maximumVisible,
} = toRefs(props);



const viewList = [5, 10, 25, 50, 100];

const viewOptions = computed(() => {
  if (itemsPerPageOptions?.value) return itemsPerPageOptions.value;
  if (footer.value.options.itemsPerPageOptions) return footer.value.options.itemsPerPageOptions;
  return viewList;
});

const total = computed(() => footer.value?.pagination?.itemsLength);

const viewFormatted = computed(() => {
  const id = viewOptions.value.findIndex((item: number) => item > total.value);
  switch (true) {
    case (id === -1):
      return viewOptions.value;
    case (id === 0):
      return [viewOptions.value[0]];
    case (id > 0):
      return viewOptions.value.slice(0, id + 1);
    default:
      return viewOptions.value;
  }
});

const isLastPage = computed(() => footer.value.pagination.page === footer.value.pagination.pageCount);

const from = computed(() => ((footer.value.pagination.page - 1) * footer.value.pagination.itemsPerPage) + 1);

const to = computed(() => (isLastPage.value
  ? total.value
  : (footer.value.pagination.page - 1) * footer.value.pagination.itemsPerPage + footer.value.pagination.itemsPerPage));

const countOfTotal = computed(() => `${from.value}-${to.value} of ${total.value}`);

const maxVisible = computed(() => maximumVisible?.value ?? 7);

const totalVisible = computed(() => (total.value < maxVisible.value ? total.value - 1 : maxVisible.value));

const disablePagination = computed(() => total.value <= viewFormatted.value[0]);

function update() {
  // If the current page is out of range, reset to 1
  const maxPage = Math.ceil(total.value / footer.value.options.itemsPerPage);
  if (footer.value.options.page > maxPage) {
    footer.value.options.page = 1;
  }
  emits('update', footer.value.options);
  // First try to find a scrollable container
  const container = (getCurrentInstance()?.proxy?.$el as HTMLElement)?.closest('.scrollable');
  if (container) {
    container.scrollTop = 0;
  } else if (scrollTo?.value) {
    // Fall back to the original scrollTo behavior
    (getCurrentInstance()?.proxy as any)?.$vuetify.goTo(scrollTo.value === 'top' ? 0 : `#${scrollTo.value}`);
  }
  (getCurrentInstance()?.proxy as any)?.$forceUpdate();
}

function input(event: number) {
  footer.value.options.page = event;
  update();
}

return { __sfc: true,props, footer, itemsPerPageOptions, scrollTo, maximumVisible, emits, viewList, viewOptions, total, viewFormatted, isLastPage, from, to, countOfTotal, maxVisible, totalVisible, disablePagination, update, input, computed, toRefs, getCurrentInstance, DataOptions }
}

})